<template>
  <div class="login">
    <div class="container">
      <div class="row">
        <div class="col content">
          <h1>Welcome to the livestream of the 2021 Private Wealth Seminar from Colorado Springs</h1>
          <p>Please login with your username and password using the form below.</p>
          <form @submit.prevent="processLogin">
            <div v-if="error" class="login-error">{{ error }}</div>
            <div class="form-field">
              <label class="control-label" for="username">Username: </label>
              <input v-model="username" type="text" name="username" class="form-control username" id="username">
            </div>
            <div class="form-group form-field">
              <label class="control-label" for="password">Password: </label>
              <input v-model="password" type="password" name="password" class="form-control password" id="password">
            </div>
            <button>Login</button>
          </form>
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
import db from '../db';
import auth from '../auth';
import helpers from '../helpers';
import router from '../router';

export default {
  name: 'Login',
  firebase: helpers.getFirebaseObject(db),
  data() {
    return {
      username: '',
      password: '',
      error: '',
    };
  },
  mounted() {
    // Auto-focus on username field
    document.getElementById('username').focus();
  },
  methods: {
    processLogin() {
      if (!this.options.live_username || !this.options.live_password) {
        setTimeout(this.processLogin, 500);
      }  
      if (!this.usernameIsValid() && !this.passwordIsValid()) {
        this.error = 'Username and password are invalid';
      } else if (!this.usernameIsValid()) {
        this.error = 'Username is invalid';
      } else if (!this.passwordIsValid()) {
        this.error = 'Password is invalid';
      } else {
        auth.registerLogin();
      }
    },
    usernameIsValid() {
      return this.options.live_username === this.username;
    },
    passwordIsValid() {
      return this.options.live_password === this.password;
    },
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container-full {
  margin-top: -23px;
  margin-bottom: 1.25em;
}

h1 {
  font-size: 32px;
}

h2 {
  color: #fdfdfd;
  text-align: center;
}
h2 a {
  color: #bdf5ff;
}

p {
  font-size: 18px;
}

.login-error {
  background: #bb1616;
  color: #fff;
  padding: 1rem;
  margin-bottom: 1rem;
  font-size: 2rem;
}

form {
  padding: 3em;
}

.form-field {
  margin-bottom: 2em;
}

label {
  font-weight: bold;
}

.form-control {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: .25rem;
  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
  -webkit-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
}

button {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  border-radius: .25rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: #fff;
  background-color: #428bca;
  border-color: #357ebd;
  font-size: 1.3em;
  padding: 0.6em 1.4em 0.4em;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue